import { toast } from "sonner"

export async function copyTextWithToast(text: string, success: string, failure: string) {
  try {
    await navigator.clipboard.writeText(text)
    toast.success(success)
  } catch {
    toast.error(failure)
  }
}
